import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { useLocation } from 'react-router-dom';

import {
  invertNavigation,
  renderPrismicContent,
} from 'app/shared/utils/prismic';
import { GetDynamicPageUrl } from 'app/shared/graphql/prismic/queryHooks';
import AnalyticsProvider from 'app/shared/context/Analytics';
import SEO from 'app/shared/components/molecules/SEO';
import Loading from 'app/shared/components/pages/Loading';
import { GlobalError, NotFound } from 'app/shared/components/pages/Status';
import Layout from 'app/shared/layouts/Main';

const localeMap: { [key: string]: string } = {
  es: 'es-es',
  en: 'en-gb',
};
const sofarToPrismicLocaleMapper = (locale: string) =>
  localeMap[locale] || locale;

const Prismic = () => {
  const intl = useIntl();
  const location = useLocation();

  const [prismicLocale, setPrismicLocale] = useState(
    sofarToPrismicLocaleMapper(intl.locale)
  );

  const { loading, error, data } = GetDynamicPageUrl({
    url: location.pathname,
    locale: prismicLocale,
  });

  if (loading) {
    return <Loading />;
  }

  if (error || !data) {
    return <GlobalError />;
  }

  if (!data.page) {
    if (prismicLocale !== 'en-gb') {
      setPrismicLocale('en-gb');
    }
    return <NotFound />;
  }

  const {
    body,
    seoTitle,
    seoDescription,
    openGraphTitle,
    openGraphDescription,
    openGraphImage,
    ldJson,
  } = data.page;

  return (
    <AnalyticsProvider>
      <Layout
        data-qaid="prismic-dynamic-page"
        centerContent
        navbarProps={{
          transparent: invertNavigation(body),
        }}
      >
        <SEO
          title={seoTitle}
          image={openGraphImage}
          description={seoDescription}
          ogTitle={openGraphTitle}
          ogDescription={openGraphDescription}
          ldJson={ldJson}
          canonicalUrlPath={location.pathname}
        />
        {renderPrismicContent(body)}
      </Layout>
    </AnalyticsProvider>
  );
};

export default Prismic;
